export default {
  home: 'Koti',
  menu: 'Valikko',
  orders: 'Tilaukset',
};
